<template>
  <Base
    :go-to-new-template-page="goToNewTemplatePage"
    :go-to-edit-template="goToEditTemplate"
    :go-to-copy-item="goToCopyItem"
    :on-delete="(params) => api.template.delete(params)"
    :on-get="(params) => api.template.get(params)"
    :on-export="(params) => api.template.exportTemplate(params)"
    :on-import="(params) => api.template.importTemplate(params)"
    new-template-text="new_ticket_templates"
    remove-template-text="remove_ticket_templates"
    :json-export-field-list="jsonExportFieldList"
  />
</template>

<script>
import Base from './base';

import api from '../../../api/index';

export default {
  title: 'Ticket-Templates',
  components: { Base },
  data() {
    return {
      api: api,
      jsonExportFieldList: ['description', 'fields', 'groups', 'name', 'defaultTeam', 'defaultUser', 'email', 'emailCC'],
    };
  },
  methods: {
    goToNewTemplatePage() {
      this.$router.push({ name: 'new-template', params: { id: Math.round(Math.random() * 10000) } });
    },
    goToEditTemplate(id) {
      this.$router.push({ name: 'edit-ticket-template', params: { id } });
    },
    goToCopyItem(id) {
      this.$router.push({ name: 'copy-template', params: { id } });
    },
  },
};
</script>
